var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('app-icon',{attrs:{"src":_vm.icon,"size":"57px"}}),_c('div',{staticClass:"header__info"},[_c('p',{staticClass:"title"},[_vm._v("\n           "+_vm._s(_vm.name)+"\n        ")]),_c('p',{staticClass:"g-text"},[_vm._v(_vm._s(_vm.description))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }